export enum Role {
  COUNTRY_ORGANISER = 'ROLE_COUNTRY_ORGANISER',
  MEMBER = 'ROLE_MEMBER',
  PARTNER = 'ROLE_PARTNER',
  WORLD_ORGANISER = 'ROLE_WORLD_ORGANISER',
}
